export enum Role {
  ADMIN='admin',
  CUSTOMER='customer',
  EMPLOYEE='employee',
}

export const getRoleName = (role: Role): string => {
  switch (role) {
    case Role.ADMIN:
      return "Administrator";
    case Role.CUSTOMER:
      return "Client";
    case Role.EMPLOYEE:
      return "Employee";
    default:
      return "Unknown";
  }
};

export const NULL_USER: User = {
  id: 0,
  userName: '',
  pwd: '',
  name: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  description: '',
  role: Role.CUSTOMER,
  notificationReviewDate: new Date('2020-01-01 00:00:00').toJSON(),
  resetPwd: false,
  forgotPwdUri: null,
  forgotPwdDate: null,
}

export default interface User {
  id: number;
  userName: string;
  pwd: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  /** Set when loaded from API (optional on older clients). */
  phone?: string;
  description: string;
  role: Role;
  notificationReviewDate: string;
  resetPwd: boolean;
  forgotPwdUri: string | null;
  forgotPwdDate: string | null;
}
